var React = require('react');

function RightArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.21782 3.8462L0.918615 6.85594C0.708063 7.04802 0.368465 7.04802 0.157913 6.85594C-0.0526378 6.66386 -0.0526378 6.35406 0.157913 6.16353L3.07677 3.50077L0.159611 0.836468C-0.0509398 0.645939 -0.0509398 0.334587 0.159611 0.144058C0.368465 -0.0480195 0.709761 -0.0480195 0.918615 0.144058L4.21782 3.1538C4.32309 3.24983 4.37573 3.3753 4.37573 3.50077C4.37573 3.6247 4.32309 3.75017 4.21782 3.8462Z","fill":"#D8AE84"}));
}

RightArrowIcon.defaultProps = {"width":"5","height":"7","viewBox":"0 0 5 7","fill":"none"};

module.exports = RightArrowIcon;

RightArrowIcon.default = RightArrowIcon;



//////////////////
// WEBPACK FOOTER
// /node_modules/svg-react-loader/lib/loader.js?name=RightArrowIcon!./components/button/assets/arrow-right-accent.svg
// module id = WXQT
// module chunks = 0